// src/blogs/AudioBlog.jsx
// The "refined" blog, presented to readers as "longer". The file/route/theme
// names still say "audio" for now — only user-facing labels were reframed.
import React from "react";

import BlogShell from "./BlogShell.jsx";
import { audioPosts } from "./blogData.js";
import { formatDate } from "./formatDate.js";
import PostBody from "./PostBody.jsx";
import PostPermalink from "./PostPermalink.jsx";
import { useScenePostClass } from "./ActivePostContext.js";
import "./AudioBlog.css";

const MINI_HEAD_TARGET = { yaw: 1, pitch: 0 };

function AudioPost({ post }) {
  const sceneClass = useScenePostClass(post);
  return (
    <article className={`audio-post ${sceneClass}`}>
      <div className="audio-post__meta">
        <span>{formatDate(post.date)}</span>
        <span>{post.extra.durationLabel}</span>
        <PostPermalink id={post.id} />
      </div>
      <h2 className="audio-post__title">{post.title}</h2>
      <PostBody post={post} textClassName="audio-post__excerpt" />
      <div className="audio-post__tags">
        {post.tags.map((tag) => (
          <span key={tag} className="audio-post__tag">
            #{tag}
          </span>
        ))}
      </div>
    </article>
  );
}

export default function AudioBlog({ onNavigateHome }) {
  return (
    <BlogShell
      themeClassName="audio-theme"
      posts={audioPosts}
      renderPost={(post) => <AudioPost key={post.id} post={post} />}
      miniHeadTarget={MINI_HEAD_TARGET}
      onNavigateHome={onNavigateHome}
      emptyLabel="longer posts"
    />
  );
}
